// Copyright (c) 2018 Deere & Company

import {hasAccess} from '../../../shared/services/security';
import {isEditable} from './return-status';

export const isEditableAndAccessible = (partReturn, security) =>
    isEditable(partReturn) && hasAccess(security, 'PART_RETURNS_EDIT', 'PART_RETURNS_EDIT');



// WEBPACK FOOTER //
// ./src/part-requests/request-details/services/is-editable-and-accessible.js